module.exports = __webpack_public_path__ + "static/img/study_btn1.ee25ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/study_btn1.png
// module id = /J/m
// module chunks = 1